import './woningaanbod.scss';
import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';
import { InertiaPlugin } from 'gsap/InertiaPlugin';

gsap.registerPlugin( Draggable, InertiaPlugin );

function initWoningaanbod() {
	const roots = document.querySelectorAll( '[data-component="woningaanbod"]' );

	if ( ! roots.length ) {
		return;
	}

	roots.forEach( ( root ) => {
		const slider = root.querySelector( '[data-woningaanbod-slider]' );
		const track = root.querySelector( '[data-woningaanbod-track]' );
		const prevBtn = root.querySelector( '.b-woningaanbod__navBtn.-prev' );
		const nextBtn = root.querySelector( '.b-woningaanbod__navBtn.-next' );

		if ( ! slider || ! track ) {
			return;
		}

		let draggableInstance = null;

		const getCardWidth = () => {
			const card = track.querySelector( '.property-card' );
			const gapStr = window.getComputedStyle( track ).gap;
			const gap = parseFloat( gapStr ) || 0;

			if ( card ) {
				return card.offsetWidth + gap;
			}
			return 340;
		};

		const getBounds = () => {
			const sliderWidth = slider.offsetWidth;
			const trackWidth = track.scrollWidth;
			const minX = Math.min( 0, sliderWidth - trackWidth );
			return { minX: minX, maxX: 0 };
		};

		const draggables = Draggable.create( track, {
			trigger: slider,
			type: 'x',
			inertia: true,
			resistance: 3000,
			edgeResistance: 0.65,
			bounds: getBounds,
			onPress() {
				gsap.killTweensOf( track );
			},
			snap: {
				x: ( value ) => {
					const step = getCardWidth();
					const snapped = Math.round( value / step ) * step;
					const bounds = getBounds();
					return Math.max( bounds.minX, Math.min( bounds.maxX, snapped ) );
				},
			},
		} );

		draggableInstance = draggables[ 0 ];

		const moveSlider = ( direction ) => {
			if ( ! draggableInstance ) {
				return;
			}

			const cardWidth = getCardWidth();
			const bounds = getBounds();
			const currentX = gsap.getProperty( track, 'x' ) || 0;
			let targetX = currentX + ( direction * cardWidth );

			targetX = Math.max( bounds.minX, Math.min( bounds.maxX, targetX ) );

			gsap.to( track, {
				x: targetX,
				duration: 0.6,
				ease: 'power3.out',
				onUpdate: () => {
					if ( draggableInstance ) {
						draggableInstance.update();
					}
				},
			} );
		};

		if ( prevBtn ) {
			prevBtn.addEventListener( 'click', () => moveSlider( 1 ) );
		}

		if ( nextBtn ) {
			nextBtn.addEventListener( 'click', () => moveSlider( -1 ) );
		}

		const handleResize = () => {
			if ( ! draggableInstance ) {
				return;
			}

			const bounds = getBounds();
			const currentX = gsap.getProperty( track, 'x' ) || 0;

			if ( currentX < bounds.minX ) {
				gsap.to( track, {
					x: bounds.minX,
					duration: 0.3,
					onUpdate: () => {
						draggableInstance.update();
					},
				} );
			} else if ( currentX > bounds.maxX ) {
				gsap.to( track, {
					x: bounds.maxX,
					duration: 0.3,
					onUpdate: () => {
						draggableInstance.update();
					},
				} );
			}
		};

		window.addEventListener( 'resize', handleResize );

		root._woningaanbodCleanup = () => {
			if ( draggableInstance ) {
				draggableInstance.kill();
			}
			window.removeEventListener( 'resize', handleResize );
		};
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initWoningaanbod );
} else {
	initWoningaanbod();
}
